import { render, staticRenderFns } from "./ClientActions.vue?vue&type=template&id=0df2cbdc&scoped=true&"
import script from "./ClientActions.vue?vue&type=script&lang=js&"
export * from "./ClientActions.vue?vue&type=script&lang=js&"
import style0 from "./ClientActions.vue?vue&type=style&index=0&id=0df2cbdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df2cbdc",
  null
  
)

export default component.exports